import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useIntl } from 'react-intl';

import { ErrorState } from '@/components/ui/error-state';
import { reportBoundaryError } from '@/utils/sentry';

import { CampaignsMetricsContent, CampaignsMetricsSkeleton } from './content';

export function CampaignsMetrics() {
  const intl = useIntl();
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          onError={reportBoundaryError('campaigns.metrics')}
          onReset={reset}
          fallbackRender={({ resetErrorBoundary }) => (
            <ErrorState
              message={intl.formatMessage({
                defaultMessage: "We couldn't load campaign metrics. Try again.",
                description:
                  'Campaign performance totals could not load; the recruiter can retry',
              })}
              onRetry={resetErrorBoundary}
            />
          )}
        >
          <Suspense fallback={<CampaignsMetrics.Skeleton />}>
            <CampaignsMetricsContent />
          </Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}

CampaignsMetrics.Skeleton = CampaignsMetricsSkeleton;
